import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "18",
  "aria-hidden": "true",
  viewBox: "0 0 16 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.143 4.5C5.143 2.946 6.42 1.688 8 1.688c1.271 0 2.35.815 2.718 1.947a.863.863 0 0 0 1.078.545.843.843 0 0 0 .554-1.062A4.56 4.56 0 0 0 8 0C5.475 0 3.429 2.014 3.429 4.5v2.25H2.286C1.025 6.75 0 7.759 0 9v6.75C0 16.991 1.025 18 2.286 18h11.428C14.975 18 16 16.991 16 15.75V9c0-1.241-1.025-2.25-2.286-2.25H5.143zM1.714 9c0-.31.257-.562.572-.562h11.428c.315 0 .572.253.572.562v6.75c0 .31-.257.563-.572.563H2.286a.57.57 0 0 1-.572-.563z" }, null, -1)
  ])))
}
export default { render: render }